import React, { useEffect, useState } from "react";

import styles from "../../PieChart.module.scss";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { MenuItem, TextField, Typography } from "@mui/material";
import { decryptedAdminID, MyModal } from "../../../../utility";
import ModalContainer from "../../../../components/modal_popup";
import { GetAllAdminDetails } from "../../../../apiServices";
import { CandidateDashboardFilterActions } from "../../../../redux-store/store";

const AdminInterviewChartFilter = () => {
  const LineFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.CandidateBarFilter
  );

  const dispatch = useDispatch();
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID == 1;
  const initialObject = {
    adminId: isSuperAdmin ? -1 : decryptedAdminID(),
    type: LineFilter.type,
    countType: LineFilter.countType,
  };
  const [adminList, setAdminList] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filters, setFilters] = useState(initialObject);
  const [selectedFilters, setSelectedFilters] = useState(null);

  useEffect(() => {
    console.log(filters, "good");

    GetAllAdminDetails()
      .then((data) => {
        console.log(data);
        const activeAdmins = data.filter(
          (item) => !item.Deactived && item.Module !== "Developer"
        );
        setAdminList(activeAdmins);
      })
      .catch(() => {
        alert("Something Went wrong");
      });
  }, []);

  const handleJobClose = () => {
    setIsFilterOpen(false);
  };

  function handleFieldChange(field, value) {
    setFilters((prev) => ({ ...prev, [field]: value }));
    dispatch()
  }

  const handleClearAll = () => {
    setFilters({
      adminId: isSuperAdmin ? -1 : decryptedAdminID(),
      type: "7days",
    });

    setSelectedFilters(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      CandidateDashboardFilterActions.setCandidateBarFilter({
        ...filters,
      })
    );
    console.log("Filter Data to be dispatched:", filters);

    setSelectedFilters(filters);
    handleJobClose();
    setIsFilterOpen(false); // Close the popup when submit is clicked
  };

  return (
    <div className={styles.filterContainer}>
      <div>
        <button
          className="btn btn-success"
          onClick={() => setIsFilterOpen(true)}
        >
          Filter
        </button>
      </div>
      {isFilterOpen && (
        <MyModal>
          <ModalContainer
            zIndex={1005}
            childComponent={
              <div style={{ width: 400 }}>
                <div className="d-flex justify-content-between align-items-center">
                  <Typography variant="h6" gutterBottom>
                    <b>Filter</b>
                  </Typography>
                  <div>
                    <button className="btn btn-danger" onClick={handleJobClose}>
                      <AiOutlineClose />
                    </button>
                  </div>
                </div>
                {isSuperAdmin && (
                  <div className="mt-2 ">
                    <TextField
                      onChange={(e) =>
                        handleFieldChange("adminId", e.target.value)
                      }
                      name="AssignedTo"
                      id="AssignedTo"
                      className="form-control"
                      select
                      label="Assigned To"
                      value={filters.adminId}
                      defaultValue={filters.adminId}
                    >
                      <MenuItem value={-1}>ALL</MenuItem>
                      {adminList.map((el) => (
                        <MenuItem key={el.id} value={el.id}>
                          {el.userName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                )}
                <div className="mt-2 ">
                  <TextField
                    onChange={(e) => handleFieldChange("type", e.target.value)}
                    name="Type"
                    id="Type"
                    className="form-control"
                    select
                    label="Chart Type"
                    value={filters.type}
                    defaultValue={filters.type}
                  >
                    <MenuItem value={"7days"}>Last 7 days</MenuItem>
                    <MenuItem value={"15days"}>Last 15 days</MenuItem>
                    <MenuItem value={"30days"}>Last 30 days</MenuItem>
                    <MenuItem value={"3months"}>Last 3 Month</MenuItem>
                    <MenuItem value={"6months"}>Last 6 Month</MenuItem>
                    <MenuItem value={"12months"}>last 1 year</MenuItem>
                  </TextField>
                </div>
                <div className="mt-2 ">
                  {/* <TextField
                    onChange={(e) =>
                      handleFieldChange("countType", e.target.value)
                    }
                    name="countType"
                    id="countType"
                    className="form-control"
                    select
                    label="Count Type"
                    value={filters.countType}
                    defaultValue={filters.countType}
                  >
                    <MenuItem value={"Joined"}>Joined</MenuItem>
                    <MenuItem value={"Left Company"}>Left Company</MenuItem>
                    <MenuItem value={"Currently Working"}>
                      Currently Working
                    </MenuItem>
                  </TextField> */}
                </div>
                <div className="d-flex justify-content-end align-items-center gap-2 mt-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleClearAll}
                    sx={{ mt: 2 }}
                  >
                    Clear All
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success"
                    sx={{ mt: 2, mr: 1 }}
                    onClick={handleSubmit}
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            }
          />
        </MyModal>
      )}
    </div>
  );
};

export default AdminInterviewChartFilter;
